import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Dropdown, Button } from "react-bootstrap";

import { setUserInfoData } from "../actions/userInfoActions";

import userAvatar from "../assets/images/user.svg";
import checked from "../assets/images/checked.svg";

export default function UserActions() {

	const dispatch = useDispatch();
	const userInfoStore = useSelector(state => state.userInfo);

	const handleChangeOrganization = (id) => {
		dispatch(setUserInfoData({
			selected: {
				organization: id,
				application: userInfoStore.data.selected.application
			}
		}));
	}

	const handleLogout = () => {
		localStorage.clear();
		sessionStorage.clear();
		window.location.reload();
	}

	return (
		<Dropdown>
			<Dropdown.Toggle className="bg-transparent text-start text-black border-0 p-0">
				<p className="SFProDisplay-Semibold m-0">
					{userInfoStore.data.list.name}
				</p>
				<p className="opacity-50 m-0">
					{userInfoStore.data.list.organizations.find(org => org.id === userInfoStore.data.selected.organization).name}
				</p>
			</Dropdown.Toggle>
			<Dropdown.Menu className="rounded-5 p-0">

				<Dropdown.Item as="li" className="py-2 px-0">
					<Row className="d-flex align-items-center m-0 py-2 px-3">
						<Col xs="auto" className="px-0">
							<img
								src={userAvatar}
								className="img-fluid"
								alt="avatar"
							/>
						</Col>
						<Col className="ps-3 pe-0">
							<p className="white-space-nowrap m-0">
								{userInfoStore.data.list.email}
							</p>
							<Link className="text-decoration-none text-primary" to="/account">
								Edit profile
							</Link>
						</Col>
					</Row>
					<Row className="border-bottom border-1 border-secondary mx-2" />
				</Dropdown.Item>

				{userInfoStore.data.list.organizations.length > 1 &&
					<>
						{userInfoStore.data.list.organizations.map((org, i) => (
							<Dropdown.Item as="li" className="py-2 px-0" key={i}>
								<Row className="d-flex align-items-center justify-content-between cursor-pointer m-0" onClick={() => handleChangeOrganization(org.id)}>
									<Col className="px-2">
										<p className="m-0">
											{org.name}
										</p>
									</Col>
									{org.id === userInfoStore.data.selected.organization &&
										<Col xs="auto" className="px-2">
											<img src={checked} className="img-fluid" alt="checked" />
										</Col>
									}
								</Row>
							</Dropdown.Item>
						))}
						<Row className="border-bottom border-1 border-secondary mx-2" />
					</>
				}

				<Dropdown.Item as="li" className="p-2">
					<Link className="text-decoration-none text-black" to="/organizations">
						Organization settings
					</Link>
				</Dropdown.Item>
				<Row className="border-bottom border-1 border-secondary mx-2" />

				<Dropdown.Item as="li" className="p-2">
					<Link className="text-decoration-none text-black" to="/team">
						Team Members
					</Link>
				</Dropdown.Item>
				<Row className="border-bottom border-1 border-secondary mx-2" />

				<Dropdown.Item as="li" className="p-2">
					<Button variant="link" className="text-decoration-none text-dark-red p-0" onClick={handleLogout}>
						Sign Out
					</Button>
				</Dropdown.Item>

			</Dropdown.Menu>
		</Dropdown>
	);
}